import React from 'react';
import type { Showcase, ShowcaseProperty, ShowcaseResource } from '../../types';
import { Check } from 'lucide-react';

interface FeaturesSectionProps {
  showcase: Showcase;
  property: ShowcaseProperty;
  resources: ShowcaseResource[];
  brandColour: string;
  darkMode?: boolean;
}

export default function FeaturesSection({ property, brandColour, darkMode: dm }: FeaturesSectionProps) {
  const features = property.key_features;
  if (!features || features.length === 0) return null;

  return (
    <section className={`py-16 transition-colors duration-300 ${dm ? 'bg-slate-800' : 'bg-slate-50'}`}>
      <div className="max-w-5xl mx-auto px-8">
        <h2 className={`text-2xl font-bold mb-8 ${dm ? 'text-white' : 'text-slate-900'}`}>Key Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {features.map((feature, idx) => (
            <div key={idx} className={`flex items-start gap-3 p-4 rounded-xl ${dm ? 'bg-slate-700' : 'bg-white'}`}>
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ backgroundColor: brandColour + '15', color: brandColour }}
              >
                <Check className="w-3.5 h-3.5" />
              </div>
              <span className={dm ? 'text-slate-200' : 'text-slate-700'}>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
